export default "__VITE_ASSET__D4IEulK1__"